import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-full space-y-4" }
const _hoisted_2 = { class: "font-semibold text-xl text-center" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = ["aria-checked", "onClick"]
const _hoisted_5 = { class: "flex justify-center h-full" }
const _hoisted_6 = { class: "max-w-[80%] w-full h-full" }
const _hoisted_7 = { class: "text-center pb-2 font-semibold" }
const _hoisted_8 = { class: "pt-2 text-center text-sm text-dark-gray-600" }
const _hoisted_9 = { class: "flex justify-center space-x-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckboxTree = _resolveComponent("CheckboxTree")!
  const _component_StepQueryState = _resolveComponent("StepQueryState")!
  const _component_CustomButton = _resolveComponent("CustomButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('views.farmToFarm.selectPeriods.title')), 1),
    _createVNode(_component_StepQueryState, {
      "is-loading": _ctx.isLoading,
      "is-error": _ctx.isError,
      onRetry: _ctx.refetch
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "period-type-choice flex justify-center overflow-x-auto mb-4",
          role: "radiogroup",
          "aria-label": _ctx.$t('views.farmToFarm.selectPeriods.title')
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periodTypeOptions, (option) => {
            return (_openBlock(), _createElementBlock("button", {
              key: option.value,
              type: "button",
              role: "radio",
              class: _normalizeClass(["mx-2", { '--active': option.value === _ctx.computedState.periodType }]),
              "aria-checked": option.value === _ctx.computedState.periodType,
              onClick: ($event: any) => (_ctx.applyPeriodType(option.value))
            }, _toDisplayString(option.label), 11, _hoisted_4))
          }), 128))
        ], 8, _hoisted_3),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.periodTypeDescription), 1),
            _createVNode(_component_CheckboxTree, {
              nodes: _ctx.nodes,
              "selected-keys": _ctx.computedState.selectedPeriods,
              "expanded-keys": _ctx.expandedYears,
              "onUpdate:selectedKeys": _ctx.applySelection,
              "onUpdate:expandedKeys": _cache[0] || (_cache[0] = ($event: any) => (_ctx.expandedYears = $event))
            }, null, 8, ["nodes", "selected-keys", "expanded-keys", "onUpdate:selectedKeys"]),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('views.farmToFarm.selectPeriods.selectedCount', { count: _ctx.computedState.selectedPeriods.length })), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["is-loading", "is-error", "onRetry"]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_CustomButton, {
        class: "max-w-32",
        "color-preset": "secondary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('back')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('views.reports.resetButtonLabel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_CustomButton, {
        disabled: _ctx.isLoading || _ctx.isError || !_ctx.computedState.selectedPeriods.length,
        class: "max-w-32",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('next')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('views.reports.nextButtonLabel')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}